module.exports = __webpack_public_path__ + "static/image/service/pc/one@3x.jpg?8529a7de";